import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useConfirmDialog } from 'contexts/ConfirmDialogContext';
import { useAsyncDispatch } from 'hooks/useAsyncDispatch';
import { createProperty, deleteProperty, updateProperty } from 'store/slices/properties';
import { createQuoteSet } from 'store/slices/marketplace';

export const useProperty = () => {
  const dispatchAction = useAsyncDispatch();
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const { openConfirmDialog } = useConfirmDialog();

  const handleCreateProperty = (property, parent, callback = () => {}) => {
    dispatchAction(createProperty({ property, parent }), {
      onSuccess: (data) => {
        enqueueSnackbar('Property has been successfully created.');
        callback(data?.property);
      },
    });
  };

  const handleUpdateProperty = (id, property, origin, callback = () => {}) => {
    dispatchAction(updateProperty({ id, property, origin }), {
      onSuccess: () => {
        enqueueSnackbar('Property has been successfully updated.');
        callback();
      },
    });
  };

  const handleDeleteProperty = (item, callback = () => {}) => {
    if (!item) return;
    openConfirmDialog({
      title: 'Delete Property',
      text: `You are about to delete a property. Click 'Delete' to proceed`,
      handler: () =>
        dispatchAction(deleteProperty({ id: item.id }), {
          onSuccess: () => {
            enqueueSnackbar(`Property has been successfully deleted.`);
            callback();
            const path = location.pathname.split('/');
            const insideEntity = path.length > 2;
            const rootFolder = path[1];
            if (insideEntity && rootFolder && rootFolder === 'properties') {
              navigate('/properties');
            }
            if (insideEntity && rootFolder && rootFolder === 'workspace') {
              navigate('/workspace');
            }
          },
          errorFallback: 'Unable to delete property',
        }),
    });
  };

  const handleCreateQuote = (selectedProperty) => {
    dispatchAction(createQuoteSet({ property: selectedProperty }), {
      onSuccess: (data) => {
        navigate(`/properties/${data?.property_id}/marketplace/${data?.id}`);
        enqueueSnackbar('Quote has been added');
        close();
      },
    });
  };

  return {
    handleCreateProperty,
    handleUpdateProperty,
    handleDeleteProperty,
    handleCreateQuote,
  };
};
